import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { CoreCommonModule } from '../../common.module';

import { CoreMenuComponent } from './core-menu/core-menu.component';
import { CoreMenuVerticalSectionComponent } from './core-menu/vertical/section/section.component';
import { CoreMenuVerticalItemComponent } from './core-menu/vertical/item/item.component';
import { CoreMenuVerticalCollapsibleComponent } from './core-menu/vertical/collapsible/collapsible.component';
import { CoreMenuHorizontalItemComponent } from './core-menu/horizontal/item/item.component';
import { CoreMenuHorizontalCollapsibleComponent } from './core-menu/horizontal/collapsible/collapsible.component';


@NgModule({
  declarations: [
    CoreMenuComponent,
    CoreMenuVerticalSectionComponent,
    CoreMenuVerticalItemComponent,
    CoreMenuVerticalCollapsibleComponent,
    CoreMenuHorizontalItemComponent,
    CoreMenuHorizontalCollapsibleComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule.forChild(),
    CoreCommonModule,
  ],
  exports: [CoreMenuComponent],
})
export class CoreMenusModule {}
